import React, { Component } from "react";
import AttachFile from "@material-ui/icons/AttachFile";
import Button from "@material-ui/core/Button";
import { PURPLE_COLOR } from "../constants";
export default class FileBase64 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
    };
  }

  handleChange(e) {
    // get the files
    let files = e.target.files;

    // Process each file
    var allFiles = [];
    for (var i = 0; i < files.length; i++) {
      let file = files[i];

      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);


      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        let fileInfo = {
          name: file.name,
          type: file.type,
          size: Math.round(file.size / 1000) + " kB",
          base64: reader.result,
          file: file
        };

        // Push it to the state
        allFiles.push(fileInfo);

        // If all files have been proceed
        if (allFiles.length == files.length) {
          // Apply Callback function
          if (this.props.multiple) this.props.onDone(allFiles);
          else this.props.onDone(allFiles[0]);
        }
      }; // reader.onload
    } // for
  }

  render() {
    return (
      <Button
        fullWidth
        variant="outlined"
        style={{ color: PURPLE_COLOR, borderColor: PURPLE_COLOR }}
        color="primary" component="label"
        size="medium"
        startIcon={<AttachFile />}
      >
        {this.props.title}
        <input
          type="file"
          hidden
          accept={".pdf"}
          onChange={this.handleChange.bind(this)}
          multiple={this.props.multiple}
        />
      </Button>
    );
  }
}

FileBase64.defaultProps = {
  multiple: false,
};
